import {
  IEnum,
  IMDMUnit,
  IMDMUnitInstance,
  IPassportGroup,
  IPassportSchema,
  IPassportSchemaField,
  TCreateEnumDTO,
  TCreateEnumValueDTO,
  TCreateMDMUnitDTO,
  TCreateMDMUnitFieldDTO,
  TCreatePassportSchemaFieldDTO,
  TCreateUnitInstanceDTO,
} from './mdm.types.ts'
import { IEquipmentPassportValue, TCreatePassportValueDTO } from '@/pages/Equipment/equipment.types.ts'

const generateCreatePrimitiveDTO = (): TCreateEnumDTO => ({ name: '', values: [] })

const generatePrimitiveValue = (): TCreateEnumValueDTO => ({ name: '' })

const generateCreateUnitDTO = (): TCreateMDMUnitDTO => ({
  name: '',
  fields: [{ name: '', type: 'STRING', typeEnumId: null, orderingIndex: 0, defaultValue: '' }],
})

const generateUnitField = (orderingIndex = 0): TCreateMDMUnitFieldDTO => ({
  name: '',
  type: 'STRING',
  typeEnumId: null,
  orderingIndex,
  defaultValue: '',
})

const generateCreatePassportValueDTO = (fieldId: IPassportSchemaField['id'] = 0): TCreatePassportValueDTO => ({
  fieldId: fieldId,
  value: '',
  enumValueId: null,
  unitValueId: null,
})

const generatePassportField = (
  orderingIndex = 0,
  groupId: IPassportGroup['id'],
  passportSchemaId: IPassportSchema['id']
): TCreatePassportSchemaFieldDTO => ({
  name: '',
  type: 'STRING',
  typeEnumId: null,
  typeUnitId: null,
  orderingIndex,
  defaultValue: '',
  groupId,
  passportSchemaId,
})

const generateCreateUnitInstanceDTO = (unit: IMDMUnit): TCreateUnitInstanceDTO => ({
  name: '',
  unitId: unit.id,
  comment: '',
  values: unit ? unit.fields.map((f) => ({ enumValueId: null, value: f.defaultValue || '-', fieldId: f.id })) : [],
})

const getFieldValue = (
  enums: IEnum[],
  unitInstances: IMDMUnitInstance[],
  value: IEquipmentPassportValue | TCreatePassportValueDTO
) => {
  if (!value) return '-'

  if (value.unitValueId) {
    return unitInstances.find((u) => u.id === value.unitValueId)?.name || '-'
  }

  if (value.enumValueId) {
    const e = enums.find((e) => e.values.some((e) => e.id === value.enumValueId))
    if (!e) return '-'

    return e.values.find((e) => e.id === value.enumValueId).name || '-'
  }

  return value.value
}

const isEquipmentPassportValuesEqual = (a: TCreatePassportValueDTO, b: TCreatePassportValueDTO) => {
  return a && b && a.enumValueId === b.enumValueId && a.unitValueId === b.unitValueId && a.value === b.value
}

const mdmUtils = {
  generateCreatePassportValueDTO,
  generateCreatePrimitiveDTO,
  generatePrimitiveValue,
  generateCreateUnitDTO,
  generateUnitField,
  generateCreateUnitInstanceDTO,
  generatePassportField,
  getFieldValue,
  isEquipmentPassportValuesEqual,
}
export default mdmUtils
